import juiceClient from 'juice/client';

import { juiceOptions } from 'app/utils/juiceOptions';

// juice throws on malformed CSS.
export function safeJuice(html: string): string {
  try {
    return juiceClient(html, juiceOptions);
  } catch {
    return html;
  }
}
